!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define(["react"], t) : "object" == typeof exports ? exports.Card = t(require("react")) : e.Card = t(e.react);
}(window, function (e) {
  return function (e) {
    var t = {};

    function r(n) {
      if (t[n]) return t[n].exports;
      var o = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }

    return r.m = e, r.c = t, r.d = function (e, t, n) {
      r.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, r.t = function (e, t) {
      if (1 & t && (e = r(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        r.d(n, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return n;
    }, r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return r.d(t, "a", t), t;
    }, r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = "", r(r.s = 1);
  }([function (t, r) {
    t.exports = e;
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0),
        o = r.n(n),
        u = {
      main: "bg-white text-gray-900 shadow-md h-full flex-col p-4",
      neutral: "bg-blue-100 flex-col px-4 py-3",
      positive: "bg-green-100 flex-col px-4 py-3",
      negative: "bg-red-100 flex-col px-4 py-3",
      alert: "bg-red-500 text-white shadow-md items-center p-4 whitespace-no-wrap"
    };

    t.default = function (e) {
      var t = e.type,
          r = e.children,
          n = u[t] + " flex flex-1 p-4 rounded-xl mb-5";
      return o.a.createElement("div", {
        className: n
      }, r);
    };
  }]);
});